@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import cz.vojtechhoranek.site.pages.AboutRedirectPage as _cz_vojtechhoranek_site_pages_AboutRedirectPage
import cz.vojtechhoranek.site.pages.HomePage as _cz_vojtechhoranek_site_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Vojtěch Hořánek"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _cz_vojtechhoranek_site_pages_HomePage()
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _cz_vojtechhoranek_site_pages_AboutRedirectPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("footer", cz.vojtechhoranek.site.components.sections.FooterStyle)
        ctx.theme.registerStyle("nav-header", cz.vojtechhoranek.site.components.sections.NavHeaderStyle)
        ctx.theme.registerStyle("markdown", cz.vojtechhoranek.site.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content", cz.vojtechhoranek.site.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("project-gallery-toggle", cz.vojtechhoranek.site.components.widgets.ProjectGalleryToggleStyle)
        ctx.theme.registerStyle("project-gallery-dialog", cz.vojtechhoranek.site.components.widgets.ProjectGalleryDialogStyle)
        ctx.theme.registerStyle("project-gallery-control", cz.vojtechhoranek.site.components.widgets.ProjectGalleryControlStyle)
        ctx.theme.registerStyle("typography-base", cz.vojtechhoranek.site.TypographyBaseStyle)
        ctx.theme.registerStyle("about-page", cz.vojtechhoranek.site.pages.AboutPageStyle)
        ctx.theme.registerStyle("about-header", cz.vojtechhoranek.site.pages.AboutHeaderStyle)
        ctx.theme.registerStyle("about-photo", cz.vojtechhoranek.site.pages.AboutPhotoStyle)
        ctx.theme.registerStyle("about-contact", cz.vojtechhoranek.site.pages.AboutContactStyle)
        ctx.theme.registerStyle("about-timeline-item", cz.vojtechhoranek.site.pages.AboutTimelineItemStyle)
        ctx.theme.registerStyle("about-timeline-date", cz.vojtechhoranek.site.pages.AboutTimelineDateStyle)
        ctx.theme.registerStyle("about-timeline-content", cz.vojtechhoranek.site.pages.AboutTimelineContentStyle)
        ctx.theme.registerStyle("about-timeline-rail", cz.vojtechhoranek.site.pages.AboutTimelineRailStyle)
        ctx.theme.registerVariant("-circle", cz.vojtechhoranek.site.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", cz.vojtechhoranek.site.UncoloredButtonVariant)
        ctx.theme.registerVariant("-display-large", cz.vojtechhoranek.site.DisplayLarge)
        ctx.theme.registerVariant("-display-medium", cz.vojtechhoranek.site.DisplayMedium)
        ctx.theme.registerVariant("-display-small", cz.vojtechhoranek.site.DisplaySmall)
        ctx.theme.registerVariant("-headline-large", cz.vojtechhoranek.site.HeadlineLarge)
        ctx.theme.registerVariant("-headline-medium", cz.vojtechhoranek.site.HeadlineMedium)
        ctx.theme.registerVariant("-headline-small", cz.vojtechhoranek.site.HeadlineSmall)
        ctx.theme.registerVariant("-title-large", cz.vojtechhoranek.site.TitleLarge)
        ctx.theme.registerVariant("-title-medium-large", cz.vojtechhoranek.site.TitleMediumLarge)
        ctx.theme.registerVariant("-title-medium", cz.vojtechhoranek.site.TitleMedium)
        ctx.theme.registerVariant("-title-small", cz.vojtechhoranek.site.TitleSmall)
        ctx.theme.registerVariant("-body-large", cz.vojtechhoranek.site.BodyLarge)
        ctx.theme.registerVariant("-body-medium", cz.vojtechhoranek.site.BodyMedium)
        ctx.theme.registerVariant("-body-small", cz.vojtechhoranek.site.BodySmall)
        ctx.theme.registerVariant("-label-large", cz.vojtechhoranek.site.LabelLarge)
        ctx.theme.registerVariant("-label-large-prominent", cz.vojtechhoranek.site.LabelLargeProminent)
        ctx.theme.registerVariant("-label-medium", cz.vojtechhoranek.site.LabelMedium)
        ctx.theme.registerVariant("-label-medium-prominent", cz.vojtechhoranek.site.LabelMediumProminent)
        ctx.theme.registerVariant("-label-small", cz.vojtechhoranek.site.LabelSmall)
        cz.vojtechhoranek.site.initSiteStyles(ctx)
        cz.vojtechhoranek.site.initColorMode(ctx)
        cz.vojtechhoranek.site.initTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        cz.vojtechhoranek.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
